module.exports = __webpack_public_path__ + "static/media/NotoscriptusLegend.436f1321.png";